/* eslint-disable no-unused-vars */
import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ROOTS_DASHBOARD } from '../routes/paths';
// hooks
import useAuth from '../hooks/useAuth';

const GuestGuard = (props) => {
  const { children } = props;
  const { isAuthenticated } = useAuth();
  // if (isAuthenticated) {
  //   return <Navigate to={ROOTS_DASHBOARD} />;
  // }
  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GuestGuard;
